class LazyVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.video = window.BAO.Utils.getElement('video', { context: this })

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this.video)
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.playpause?.exists) return

    this.video = window.BAO.Utils.getElement('video', { context: this })

    this.handlePlayPause = this.handlePlayPause.bind(this)
    this.listeners.add(
      this.els.playpause.element,
      'click',
      this.handlePlayPause,
    )

    this.handleMuteUnmute = this.handleMuteUnmute.bind(this)
    this.listeners.add(
      this.els.muteunmute.element,
      'click',
      this.handleMuteUnmute,
    )

    this.handleVideoProgress = this.handleVideoProgress.bind(this)
    this.listeners.add(this.video, 'timeupdate', this.handleVideoProgress)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    if (prefersReducedMotion) {
      this.video.removeAttribute('autoplay')
      this.video.setAttribute('controls', '')
      this.video.pause()
    }

    if (this.video.dataset?.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE' &&
        videoSource.dataset?.src
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.video.load()
    observer.unobserve(this.video)

    this.setAttribute('loaded', '')

    if (
      window.BAO.MediaBreakpoints.isSm ||
      this.video.hasAttribute('autoplay') === false
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused) {
          this.video.play()
        }
      })
    }
  }

  handlePlayPause () {
    if (this.video.paused) {
      this.video.play()
      this.els.playpause.element.classList.toggle(
        'util-Video_PlayPause-playing',
        true,
      )
    } else {
      this.video.pause()
      this.els.playpause.element.classList.toggle(
        'util-Video_PlayPause-playing',
        false,
      )
    }
  }

  handleMuteUnmute () {
    if (this.video.muted) {
      this.video.muted = false
      this.els.muteunmute.element.classList.toggle(
        'util-Video_MuteUnmute-muted',
        false,
      )
    } else {
      this.video.muted = true
      this.els.muteunmute.element.classList.toggle(
        'util-Video_MuteUnmute-muted',
        true,
      )
    }
  }

  handleVideoProgress () {
    const currentTime = this.video.currentTime
    const totalTime = this.video.duration

    const progress = (100 * currentTime) / totalTime

    this.els.progress.element.style.setProperty(
      '--Progress_Percent',
      `${progress}%`,
    )
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
